import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useMainContext } from "../../../Context";
import { useQuery } from "../../../Hooks";
import { listWeb, nesdata } from "../../../Utils/Apis";

export const useList = () => {
  const [data, setData] = useState({});
  const [init, setInit] = useState({});
  const [loading, setLoading] = useState(true);
  const [drawer, setDrawer] = useState(false);
  const [initLoading, setInintLoading] = useState(true);
  const [nextLoading, setNextLoading] = useState(false);
  const navigate = useNavigate();
  const { changeObj, searchParams, clear, getValue } = useQuery({
    filters: [{ key: "search" }],
  });

  const { citySlug } = useParams();
  const {
    handler,
    post,
    state: { search, city, category, parent_Category, ...otherData },
    dispatch,
    setState,
  } = useMainContext();

  const getNext = async (url) => {
    setNextLoading(true);
    const { data: result } = await post(url);

    const newData = {
      ...data,
      data: data.data.concat(result.data),
      next_page_url: result.next_page_url
    }

    setData(newData);
    setNextLoading(false);
  };

  const clearFilters = () => {
    setState({ ...otherData, city: {}, category: {} });
    clear();
  };
  const getNeed = async () => {
    const { data, status } = await post(nesdata, {
      needkey: ["categories", "options"],
    });
    handler("search", data);
  };
  const renderFilterObj = () => {
    const isParent = localStorage.getItem("isParent") == "true" ? true : false

    if (isParent) {
      console.log("in p");
      return {
        category_parent_id: parent_Category?.id,
        city_id: city?.value,
      };
    }

    console.log("in c");
    return {
      category_id: category?.id,
      city_id: city?.value,
    };
  };

  const get = async () => {
    setLoading(true);
    const { data } = await post(listWeb, {
      citySlug,
      ...renderFilterObj(),
    });
    setData(data);
    setLoading(false);
  };

  useEffect(() => {
    get();
  }, [city, category]);

  useEffect(() => {
    getNeed();
  }, []);

  return {
    data,
    loading,
    changeObj,
    init,
    search,
    getValue,
    clearFilters,
    drawer,
    setDrawer,
    navigate,

    city,
    category,
    dispatch,
    changeObj,
    nextLoading,
    getNext
  };
};
